import {ReactComponent as ValidationIcon} from "../assets/icons/validation.svg";
import {ReactComponent as InfoIcon} from "../assets/icons/info.svg";
import {ReactComponent as WarningIcon} from "../assets/icons/warning.svg";
import {ReactComponent as ErrorIcon} from "../assets/icons/error.svg";
import {ReactComponent as CloseIcon} from "../assets/icons/close.svg";
import { JSX, useEffect } from "react";
import "../stylesheets/notification.scss";

// TYPES

type NotificationProps = {
    id:string;
    type: "validation" | "info" | "warning" | "error",
    title: string,
    subtitle?:string,
    duration?:number,
    onClose: (id:string) => void;
}

// CONST

const ICON_MAP: Record<NotificationProps["type"], JSX.Element> = {
    validation: <ValidationIcon />,
    info: <InfoIcon />,
    warning: <WarningIcon />,
    error: <ErrorIcon />,
};

// COMPONENT

function Notification({id,duration = 3000, type, title, subtitle, onClose} : NotificationProps) {
    useEffect(() => {
        const timer = setTimeout(() => onClose(id), duration);
        return () => clearTimeout(timer);

    }, [id, duration, onClose]);
    return (
        <div className={"notification " + type}>
            {ICON_MAP[type]}
            <div>
                <span>{title}</span>
                {subtitle && <span>{subtitle}</span>}
            </div>
            <CloseIcon onClick={() => onClose(id)} className="close-notification"/>
            <div className="progress-bar" style={{ animationDuration: `${duration}ms` }} />
        </div>
    )
}

export default Notification;